import { render } from "./PaperPlusIcon.vue?vue&type=template&id=1053e5dd"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/PaperPlusIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1053e5dd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1053e5dd', __exports__)) {
    api.reload('1053e5dd', __exports__)
  }
  
  module.hot.accept("./PaperPlusIcon.vue?vue&type=template&id=1053e5dd", () => {
    api.rerender('1053e5dd', render)
  })

}


export default __exports__